module.exports = __webpack_public_path__ + "static/media/p2008desert.8ba927cd.jpg";